import { faqData } from "../constants/Faqs";

export const GetFrequentlyAskedQuestion = () => faqData;
